import { render, staticRenderFns } from "./InvitationLink.vue?vue&type=template&id=2fe220e3&scoped=true"
import script from "./InvitationLink.vue?vue&type=script&lang=js"
export * from "./InvitationLink.vue?vue&type=script&lang=js"
import style0 from "./InvitationLink.vue?vue&type=style&index=0&id=2fe220e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe220e3",
  null
  
)

export default component.exports